import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useTranslation } from 'react-i18next';
import { PageUrl } from '../../../types/enums';
import MenuItem from '@mui/material/MenuItem';
import { initialState, IProps } from './SCUIProductCommentDetailForm.config';
import { Box, Card, CardContent, Grid, Rating, Chip, TextField } from '@mui/material';
import TimeHelper from '../../../../src/utils/time';
import { SCUIButton, SCUIAutoCompleteInput } from '../../atoms';
import Swal from 'sweetalert2';
import Fade from '@mui/material/Fade';
import LinearProgress from '@mui/material/LinearProgress';
import { CommentQuery } from '../../../services/query';
import './SCUIProductCommentDetailForm.scss';
import AuthService from '../../../services/auth/Auth.services';
import Helper from '../../../utils/helper';
import jwt_decode from 'jwt-decode';
import { enumCommentStatusFlowChipColor } from '../../../types/enums/status';
import { CommentCommand } from '../../../services/command';

export const SCUIProductCommentDetailForm: FC<IProps> = ({ id, history, onClose }) => {
    const { t } = useTranslation();
    const [tagName, setTagName] = React.useState<any[]>([]);
    const [tagNames, setTagNames] = React.useState([]);
    const [displayedTags, setDisplayedTags] = React.useState([]);
    const [statusName, setStatusName] = React.useState('');
    const [commentUrl, setCommentUrl] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [firstLastName, setFirstLastName] = useState('');
    const [userName, setUserName] = useState(' ');
    const [atananKisi, setAtananKisi] = useState(' ');
    const [status, setStatus] = useState(' ');
    const [commentDetail, setCommentDetail] = useState<any>(initialState.CommentDetailType);
    const [grievanceName, setGrievanceName] = useState('');
    const [grievanceDetail, setGrievanceDetail] = useState('');
    const enumCommentFlowStatusTrName: any = {
        1: t('general.waitingForApproval'),
        2: t('general.approved'),
        3: t('general.declined'),
    };
    const authService = new AuthService();
    interface JwtPayload {
        preferred_username: string;
    }
    const commentId = history?.location?.state?.yorumId ? history?.location?.state?.yorumId : id;
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        // GetCommentStatusList();
    }, [history?.location?.state?.yorumId, id]);
    useEffect(() => {
        GetCommentTicketList();
        getCommentDetail(commentId);

        getUserName();
    }, [history?.location?.state?.yorumId, id]);

    useEffect(() => {
        if (customerId) GetSingleCustomer();
    }, [customerId]);

    const GetSingleCustomer = async () => {
        try {
            let customerInfo: any = await CommentQuery.GetCustomer(customerId);
            setFirstLastName(
                customerInfo.data.customer
                    ? customerInfo.data.customer.firstName + ' ' + customerInfo.data.customer.lastName
                    : '-'
            );
            setPhoneNumber(customerInfo.data.customer ? customerInfo.data.customer.phoneNumber : '-');
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const _handlChangeTag = (event: any, newValue: any) => {
        setDisplayedTags(newValue);
        setTagName(
            newValue.map(function (item: any) {
                return item.id;
            })
        );
    };

    useEffect(() => {
        setDisplayedTags(tagNames && tagNames.filter((item: any) => tagName?.includes(item.id)));
    }, [tagNames, tagName]);
    const getUserName = () => {
        authService.getUserInfo().then((getUserInfo: any) => {
            if (!Helper.isNil(getUserInfo)) {
                const decodedToken = jwt_decode<JwtPayload>(getUserInfo.access_token);
                setUserName(decodedToken.preferred_username.toLowerCase());
            }
        });
    };

    const other_link: any = import.meta.env.VITE_APPURL!;

    const _handleChangeStatus = (event: any) => {
        setStatusName(event.target.value as string);
    };
    const _handleChangeGrievence = (event: any) => {
        setGrievanceName(event.target.value as string);
        setGrievanceDetail('');
    };
    const _handleChangeGrievenceDetail = (event: any) => {
        setGrievanceDetail(event.target.value as string);
    };

    const GetCommentTicketList = async () => {
        try {
            let commentText: any = await CommentQuery.GetCommentTicketList();
            setTagNames(commentText.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    const getCommentDetail = async (id: any): Promise<any> => {
        try {
            let params = { id: id };
            let commentInfo: any = await CommentQuery.GetCommentDataByIdV2(params);
            setCustomerId(commentInfo.customerId);
            setCommentDetail(commentInfo);
            setAtananKisi(commentInfo.userOperatorName);
            setStatus(enumCommentFlowStatusTrName[commentInfo?.status]);
            setStatusName(commentInfo.status);
            setCommentUrl(commentInfo.optionUrl);
            setGrievanceDetail(commentInfo.grievanceStatusText);
            setTagName(
                commentInfo.tag
                    ? commentInfo.tag
                          .split('_')
                          .filter((i: any) => i.length > 0)
                          .map(Number)
                    : []
            );
            setGrievanceName(commentInfo.grievanceStatus);
            setLoading((prevLoading) => !prevLoading);
        } catch (error) {
            console.info(error);
        }
    };
    const postAssignToMe = async (): Promise<any> => {
        let params = { rowId: Number(commentId), assignedOperator: atananKisi };
        CommentCommand.PostAssigToMe(params)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: t('general.completed'),
                    showConfirmButton: false,
                    timer: 1500,
                });
                setAtananKisi(userName);
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: t('general.failed'),
                    showConfirmButton: false,
                    timer: 1500,
                });
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    const getParams = () => {
        const arr = tagName.map(String);
        let params: any = {};
        params.commentId = Number(commentId);
        params.operation = statusName.toString();
        params.grievanceStatus = grievanceName.toString();
        params.tickets = arr;
        params.grievanceStatusText = grievanceDetail;
        return params;
    };
    const tamamla = async () => {
        let params: any = getParams();
        if (params.operation === '1') params.operation = '0';
        CommentCommand.PostCommentStatusUpdate(params)
            .then((res: any) => {
                if (res.rejectMessage.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.rejectMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                if (res.assigntoMessage.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.assigntoMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                if (res.operationMessageStatus.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.operationMessageStatus.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });

                if (res.operationMessage.visible) {
                    Swal.fire({
                        icon: 'success',
                        title: res.operationMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    return (
        <Grid className="commentDetailGrid">
            <Box>
                <Fade in={loading} unmountOnExit>
                    <LinearProgress />
                </Fade>
            </Box>
            <Grid container>
                <Grid
                    sx={{ paddingLeft: '2rem' }}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 6,
                    }}
                >
                    <h1 className="headtxt">
                        {t('commentDetail.header')}- {commentDetail?.id}
                    </h1>
                </Grid>
                <Grid
                    size={{
                        md: 5,
                        xs: 5,
                        lg: 5,
                    }}
                >
                    <Chip label={status} color={enumCommentStatusFlowChipColor[statusName]?.statusType} />
                </Grid>
                <Grid
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    {window.location.href.indexOf('detail') > -1 ? (
                        <Link to={PageUrl.commentList.url} className="linktxt">
                            <CloseIcon className="svg_icons" />
                        </Link>
                    ) : (
                        <CloseIcon className="svg_icons" onClick={onClose} />
                    )}
                </Grid>
            </Grid>
            <Grid container sx={{ paddingLeft: '1rem' }}>
                <Grid
                    sx={{ paddingLeft: '1rem' }}
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                    }}
                >
                    <b>{t('commentDetail.information')}</b>
                </Grid>
                <br />
                <Grid
                    size={{
                        md: 4,
                        xs: 12,
                        lg: 4,
                    }}
                >
                    <Box
                        component="img"
                        sx={{
                            paddingLeft: '1rem',
                            maxHeight: { xs: 512, lg: 512 },
                            maxWidth: { xs: 512, lg: 512 },
                            borderRadius: 1,
                            width: '-webkit-fill-available',
                        }}
                        src={commentDetail?.optionImgUrl?.replace('120', '256')}
                        loading="lazy"
                    />
                    <SCUIButton
                        text={t('general.goToProduct')}
                        type="ghost"
                        sizeType="default"
                        size="l"
                        onClick={() => window.open(commentUrl, '_blank')}
                    />
                </Grid>

                <Grid
                    sx={{ marginLeft: '3rem' }}
                    size={{
                        md: 7,
                        xs: 12,
                        lg: 7,
                    }}
                >
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('general.customerId')}:</b>{' '}
                            <a
                                target="_blank"
                                className="linktxt"
                                href={other_link + '/customerManagement?customerId=' + commentDetail?.customerId}
                                rel="noreferrer"
                            >
                                {commentDetail?.customerId}
                            </a>
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('general.phoneNumber')}: </b> {phoneNumber}
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>
                                {t('general.name')} {t('general.surname')}:{' '}
                            </b>{' '}
                            {firstLastName}
                        </div>
                    </Grid>

                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b> {t('general.eMail')}: </b>
                            <a
                                target="_blank"
                                className="linktxt"
                                href={other_link + '/customerManagement?customerId=' + commentDetail?.customerId}
                                rel="noreferrer"
                            >
                                {commentDetail?.userEmail}
                            </a>
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b> {t('comments.specialCode') + ' - ' + t('comments.colorCode')}: </b>
                            {commentDetail?.specialCode} - {commentDetail?.colorcode}
                        </div>
                    </Grid>
                    {/* <Grid item md={12} xs={12}>
            <div className="txt-detail">
              <b>{t('comments.colorCode')}: </b> {commentDetail?.colorcode}
            </div>
          </Grid> */}
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('general.point')}: </b>
                            <Rating name="read-only" value={commentDetail?.starScore} size="large" readOnly />
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('commentDetail.commentDate')}: </b> {TimeHelper.formatDate(commentDetail.commentDate)}
                        </div>
                    </Grid>

                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b> {t('comments.appointedPerson')}: </b>
                            {atananKisi}
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('general.orderSiparis')} ID:</b>{' '}
                            <a
                                target="_blank"
                                className="linktxt"
                                href={'/orderdetail?orderId=' + commentDetail?.orderId}
                                rel="noreferrer"
                            >
                                {commentDetail?.orderId}
                            </a>
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div className="txt-detail">
                            <b>{t('general.shipping')} ID:</b>{' '}
                            <a
                                target="_blank"
                                className="linktxt"
                                href={other_link + '/orderdetail?orderId=' + commentDetail?.orderId}
                                rel="noreferrer"
                            >
                                {commentDetail?.shipmentId}
                            </a>
                        </div>
                    </Grid>
                </Grid>
                <Grid
                    sx={{ paddingLeft: '1rem' }}
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                    }}
                >
                    <b> {t('comments.comment')} </b>
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <div className="yorumDiv">{commentDetail.commentText}</div>
                </Grid>
                <Grid
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Card>
                        <CardContent>
                            <Grid spacing={3} container sx={{ marginTop: '1rem' }}>
                                <Grid
                                    size={{
                                        md: 12,
                                        xs: 12,
                                        lg: 12,
                                    }}
                                >
                                    <FormControl fullWidth>
                                        {displayedTags && (
                                            <SCUIAutoCompleteInput
                                                defValue={displayedTags}
                                                list={tagNames}
                                                onChange={_handlChangeTag}
                                                limitTags={1}
                                                txtPlaceHolder={t('general.tag')}
                                                searchValue="keyWord"
                                            />
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid
                                    size={{
                                        md: 12,
                                        xs: 12,
                                        lg: 12,
                                    }}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel id="statusSelectLabel">{t('general.operation')}</InputLabel>
                                        <Select
                                            labelId="statusSelectLabel"
                                            fullWidth
                                            id="statusSelect"
                                            value={statusName}
                                            label="Durum"
                                            onChange={_handleChangeStatus}
                                        >
                                            <MenuItem value={2}>{t('general.approved')}</MenuItem>
                                            <MenuItem value={3}>{t('general.declined')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid
                                    size={{
                                        md: 12,
                                        xs: 12,
                                        lg: 12,
                                    }}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel id="grievanceSelectLabel">{t('comments.grievance')}</InputLabel>
                                        <Select
                                            labelId="grievanceSelectLabel"
                                            fullWidth
                                            id="grievanceSelect"
                                            value={grievanceName}
                                            label={t('comments.grievance')}
                                            onChange={_handleChangeGrievence}
                                        >
                                            {/* <MenuItem value={1}>
                        {t('general.belirsiz')}
                      </MenuItem> */}
                                            <MenuItem value={1}>{t('general.var')}</MenuItem>
                                            <MenuItem value={0}>{t('general.giderildi')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {grievanceName == '1' && (
                                    <Grid
                                        style={{ marginTop: '1rem' }}
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <TextField
                                            label={t('comments.grievanceDetail')}
                                            defaultValue={grievanceDetail}
                                            variant="outlined"
                                            type="text"
                                            id="grievanceDetailText"
                                            fullWidth
                                            onChange={_handleChangeGrievenceDetail}
                                        />
                                    </Grid>
                                )}

                                <Grid
                                    size={{
                                        lg: 6,
                                        md: 6,
                                        xs: 6,
                                    }}
                                >
                                    <SCUIButton
                                        text={t('general.assignToMe')}
                                        type="primary"
                                        sizeType="fixed"
                                        size={'m'}
                                        buttonType="button"
                                        onClick={() => postAssignToMe()}
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 6,
                                        md: 6,
                                        xs: 6,
                                    }}
                                >
                                    <SCUIButton
                                        text={t('general.complete')}
                                        type="primary"
                                        sizeType="fixed"
                                        size={'m'}
                                        buttonType="button"
                                        onClick={tamamla}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    );
};
